import { createVNode as _createVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createVNode("div", {
  class: "bg-white inset-0 fixed",
  style: {"z-index":"-1"}
}, null, -1)
const _hoisted_2 = { class: "container mx-auto max-w-screen-md mt-4 text-black" }
const _hoisted_3 = /*#__PURE__*/_createVNode("h1", { class: "font-bold font-raleway text-center text-brand-darkBlue mb-4 text-4xl" }, " Leaderboard ", -1)
const _hoisted_4 = /*#__PURE__*/_createVNode("i", { class: "mr-2 fas fa-arrow-left" }, null, -1)
const _hoisted_5 = /*#__PURE__*/_createTextVNode("Back to results ")

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_router_link = _resolveComponent("router-link")
  const _component_leaderboard_component = _resolveComponent("leaderboard-component")

  return (_openBlock(), _createBlock(_Fragment, null, [
    _hoisted_1,
    _createVNode("div", null, [
      _createVNode("div", _hoisted_2, [
        _hoisted_3,
        _createVNode(_component_router_link, {
          to: "/results",
          class: "rounded font-raleway text-left mb-2 block underline"
        }, {
          default: _withCtx(() => [
            _hoisted_4,
            _hoisted_5
          ]),
          _: 1
        }),
        _createVNode(_component_leaderboard_component)
      ])
    ])
  ], 64 /* STABLE_FRAGMENT */))
}